import React from "react";
import {create} from "zustand/react";

export interface ModalModel {
    title?: string;
    description?: string;
    content?: React.ReactNode;
    buttons?: ({isPending, closeDialog}: {
        isPending: boolean,
        closeDialog: () => void,
    }) => React.ReactNode[];
}

export interface ModalState {
    isPending?: boolean;
    modalModel?: ModalModel;
    showModal: (model: ModalModel) => void;
    setIsPending: (isPending: boolean) => void;
    closeModal: () => void;
}

export const useModalStore = create<ModalState>((set, getState) => ({
    modalModel: undefined,
    isPending: false,
    showModal: (model) => {
        set((state) => ({
            ...state,
            modalModel: model,
            isPending: false,
        }));
    },
    closeModal: () => {
        set((state) => ({
            ...state,
            modalModel: undefined,
            isPending: false
        }));
    },
    setIsPending: (isPending) => {
        set((state) => ({
            ...state,
            isPending
        }))
    }
}));
